module.exports = __webpack_public_path__ + "img/70.35bd7f74.png";